import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';
import { Client as DiffusionApiClient, type UserSettings } from '$lib/diffusionApi';

export class UserSettingsClient {
	private diffusionApiClient: DiffusionApiClient;

	constructor(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public setToken(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public async getUserSettings(): Promise<UserSettings | undefined> {
		try {
			const response = await this.diffusionApiClient.default.getUserSettingsUserSettingsGet();
			return response.user_settings;
		} catch (error) {
			console.error('Error fetching user settings:', error);
			return undefined;
		}
	}

	public async patchUserSettings(
		userId: string,
		isAutomaticImageStorageOn: boolean | undefined
	): Promise<void> {
		try {
			await this.diffusionApiClient.default.patchUserSettingsUserSettingsPatch({
				user_id: userId,
				is_automatic_image_storage_on: isAutomaticImageStorageOn
			});
		} catch (error) {
			console.error('Error updating user settings:', error);
		}
	}
}
